import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/quanta/QuantaLayoutClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/i18n/FeatureIntlProvider.tsx");
